export const criticalMuiEmotionStyles = `
  body {
    margin: 0;
    padding: 0;
    font-family: 'Inter', sans-serif;
    background-color: #ffffff;
  }
  
  .MuiContainer-root, [class*="MuiContainer-"] {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;
    max-width: 1200px;
  }
  
  .MuiGrid-container, [class*="MuiGrid-container"] {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    box-sizing: border-box;
  }
  
  .MuiGrid-item, [class*="MuiGrid-item"] {
    box-sizing: border-box;
    margin: 0;
  }
  
  .MuiPaper-root, [class*="MuiPaper-"], .MuiCard-root, [class*="MuiCard-"] {
    background-color: #fff;
    color: rgba(0, 0, 0, 0.87);
    box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2),
               0px 1px 1px 0px rgba(0,0,0,0.14),
               0px 1px 3px 0px rgba(0,0,0,0.12);
    border-radius: 4px;
    overflow: hidden;
  }
  
  .MuiTypography-root, [class*="MuiTypography-"] {
    margin: 0;
    font-family: 'Montserrat', sans-serif;
  }
  
  .MuiBox-root, [class*="MuiBox-"] {
    box-sizing: border-box;
  }
  
  .HeroBlock {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 16px;
    text-align: center;
  }

  .flex {
    display: flex;
  }
  .flex-column {
    flex-direction: column;
  }
  .items-center {
    align-items: center;
  }
  .justify-center {
    justify-content: center;
  }
  .w-full {
    width: 100%;
  }
`;
